import { createLucideIcon } from "lucide-react"

export const CircleCheckFilled = createLucideIcon("CircleCheckFilled", [
  [
    "path",
    {
      key: "circle-check-filled",
      d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0M7.586 12 11 15.414 16.414 10 15 8.586l-4 4-2-2z",
      fill: "currentColor",
      stroke: "none",
      fillRule: "evenodd",
      clipRule: "evenodd",
    },
  ],
])
